// Téléphone Ringover intégré (SDK officiel, iframe) : appels directs dans le CRM, sans extension Chrome
const SDK_URL = "https://webcdn.ringover.com/resources/SDK/1.1.3/ringover-sdk.js";

let sdk = null;
let inline = null;
let loading = null;
let onIncoming = null;

export const setIncomingHandler = (fn) => { onIncoming = fn; };
// Abonnés à l'état d'appel (true = appel en cours / qui sonne, false = raccroché)
const callListeners = new Set();
export const onCallActivity = (fn) => { callListeners.add(fn); return () => callListeners.delete(fn); };
const emit = (active) => callListeners.forEach((fn) => fn(active));
const listen = (instance) => {
  instance.on("ringingCall", (e) => { emit(true); if (instance === sdk && !inline) showFloat(sdk); if (e?.data?.direction === "in" && onIncoming) onIncoming(e.data.from_number); });
  instance.on("answeredCall", () => emit(true));
  instance.on("hangupCall", () => emit(false));
};

const loadScript = () => {
  if (window.RingoverSDK) return Promise.resolve();
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = SDK_URL;
      s.async = true;
      s.crossOrigin = "anonymous";
      s.onload = resolve;
      s.onerror = () => { loading = null; reject(new Error("Le téléphone Ringover n'a pas pu se charger.")); };
      document.head.appendChild(s);
    });
  }
  return loading;
};

export const callMode = () => "embedded";

export const toE164 = (phone) => {
  const raw = String(phone || "").replace(/[^\d+]/g, "");
  if (raw.startsWith("+")) return raw;
  if (raw.startsWith("00")) return `+${raw.slice(2)}`;
  if (raw.startsWith("0")) return `+33${raw.slice(1)}`;
  return `+${raw}`;
};

export async function startPhone() {
  await loadScript();
  if (!sdk) {
    sdk = new window.RingoverSDK({ type: "fixed", size: "medium", position: { bottom: "70px", right: "20px" }, animation: true, trayicon: false });
    sdk.generate();
    listen(sdk);
    sdk.hide();
  }
  return sdk;
}

// Bouton « Masquer » sous le téléphone flottant : il ne reste jamais bloqué à l'écran
let closer = null;
const hideFloat = () => { if (sdk) sdk.hide(); if (closer) { closer.remove(); closer = null; } };
const showFloat = (phoneSdk) => {
  phoneSdk.show();
  if (closer) return;
  closer = document.createElement("button");
  closer.type = "button";
  closer.className = "rg-float-close";
  closer.textContent = "✕  Masquer le téléphone";
  closer.setAttribute("data-testid", "ringover-float-close");
  closer.onclick = hideFloat;
  document.body.appendChild(closer);
};

export async function dial(phone) {
  emit(true);
  if (inline) { inline.dial(toE164(phone)); return; }
  const phoneSdk = await startPhone();
  showFloat(phoneSdk);
  phoneSdk.dial(toE164(phone));
}

// Téléphone affiché dans un emplacement de la page (ex. fiche opportunité)
export async function mountInline(containerId) {
  await loadScript();
  if (inline) inline.destroy();
  inline = new window.RingoverSDK({ type: "relative", size: "auto", container: containerId, border: false, animation: false, trayicon: false });
  inline.generate();
  listen(inline);
  hideFloat();
}

export function unmountInline() {
  if (inline) { inline.destroy(); inline = null; }
}

export function stopPhone() {
  hideFloat();
  if (sdk) { sdk.destroy(); sdk = null; }
}
